import { render, staticRenderFns } from "./MotoboyDeliveryList.vue?vue&type=template&id=19bf1d7b&scoped=true&"
import script from "./MotoboyDeliveryList.vue?vue&type=script&lang=js&"
export * from "./MotoboyDeliveryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf1d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19bf1d7b')) {
      api.createRecord('19bf1d7b', component.options)
    } else {
      api.reload('19bf1d7b', component.options)
    }
    module.hot.accept("./MotoboyDeliveryList.vue?vue&type=template&id=19bf1d7b&scoped=true&", function () {
      api.rerender('19bf1d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/delivery/MotoboyDeliveryList.vue"
export default component.exports